import React, { useState } from 'react'
import { firestore } from '../../../firebase'
import ImagePickerReturnUrl from '../Media/templates/ImagePickerReturnUrl'
import TeamsSelector from '../Team/TeamsSelector'

function AddPlayer() {

    const [name, setName] = useState("")
    const [image, setImage] = useState("")

    const [teamId, setTeamId] = useState("")
    const [teamName, setTeamName] = useState("")

    const [position, setPosition] = useState("1")
    const [number, setNumber] = useState("99")

    const [show, setShow] = useState(false)

    const [error, setError] = useState("");
    const [added, setAdded] = useState(false)

    async function addPlayerHandler(e) {
        e.preventDefault()
        if (!image || !name) {
            setError("Fyll ut navn og bilde")
            return
        }
        try {
            const playerRef = firestore.collection("players-fb");
            const date = new Date();

            const data = {
                date_added: date,
                player_image: image,
                player_name: name,
                current_team_id: teamId,
                current_team_name: teamName,
                player_number: number,
                position: position
            }
            playerRef.add(data);
            setAdded(true)

        } catch (error) {
            setError(error.message);
            setAdded(false)
        }
    }

    return (
        <form onSubmit={addPlayerHandler}>
            <label>Navn</label>
            <input value={name} onChange={e => setName(e.target.value)} className="form-control mb-2" />

            <label>Bilde</label>
            <input value={image} onChange={e => setImage(e.target.value)} className="form-control mb-2" />
            {image && <div><img src={image} alt="" className="img-fluid" style={{maxWidth: "50%"}} /></div>}
            <div className="btn btn-sm btn-rounded btn-success" onClick={() => setShow(true)}>Legg til bilde fra galleri</div>
            <ImagePickerReturnUrl show={show} setShow={setShow} imageUrl={image} setImageUrl={setImage} />

            <TeamsSelector setTeamId={setTeamId} teamId={teamId} teamName={teamName} setTeamName={setTeamName}  />

            {error && <div className="alert alert-danger">{error}</div>}
            {added && <div className="alert alert-success">Lagt til!</div>}
            <button className="btn btn-primary btn-rounded">Legg til spiller</button>

        </form>
    )
}
export default AddPlayer